import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'

import Dropdown from 'components/form/dropdown'

import { projectWorkflowTransitionsSelector, projectWorkflowStateToChangeToSelector } from './selectors'

import { updateStateToChangeTo } from './actions'

const mapStateToProps = state => {
  return {
    stateToChangeTo: projectWorkflowStateToChangeToSelector(state),
    stateOptions: projectWorkflowTransitionsSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateStateToChangeTo: (state) => dispatch(updateStateToChangeTo(state))
  }
}

class LifecycleEdit extends Component {

  render(){
    const {
      stateToChangeTo,
      stateOptions,
      updateStateToChangeTo
    } = this.props

    return (
      <div styleName='lifecycleEditContainer'>
        <Dropdown 
          title='Select state to transition to' 
          source={stateOptions} 
          value={stateToChangeTo} 
          defaultValue='Select state'
          onChange={updateStateToChangeTo}
        />
      </div>
    );
  }
    
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(LifecycleEdit);